import React from 'react';
/**
 * Object 对象小工具
 * @Author gufuyan
 * @Date 2018-08-30
 */
class ObjectFn {
    //函数参数默认值
    constructor() {

    }

    merge = (o1, o2)=> {
        for (var p in o2) {
            o1[p] = o2[p];
        }
        return o1;
    }
}

let _Object = new ObjectFn();

export {_Object}